"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var browser_info_1 = require("./browser_info");
var lodash_1 = require("lodash");
var BrowserInfoHiddenFields = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserInfoHiddenFields, _super);
    function BrowserInfoHiddenFields() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserInfoHiddenFields.prototype.renderBrowserInfo = function () {
        var _this = this;
        return lodash_1.map(browser_info_1.browserInfo(), function (value, key) {
            return (React.createElement("input", { type: "hidden", name: _this.props.inputPrefix + "[" + key + "]", key: _this.props.inputPrefix + "-" + key, value: value }));
        });
    };
    BrowserInfoHiddenFields.prototype.render = function () {
        return (React.createElement("div", null, this.renderBrowserInfo()));
    };
    BrowserInfoHiddenFields.defaultProps = {
        inputPrefix: 'browser_info',
    };
    return BrowserInfoHiddenFields;
}(React.Component));
exports.default = BrowserInfoHiddenFields;
//# sourceMappingURL=browser_info_hidden_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/browser_info_hidden_fields.js
// module id = Fd15
// module chunks = 20 21